import { render, staticRenderFns } from "./DestinationRoutes.vue?vue&type=template&id=76c56344&"
import script from "./DestinationRoutes.vue?vue&type=script&lang=ts&"
export * from "./DestinationRoutes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports